import { render, staticRenderFns } from "./grassRootsPartySchool.vue?vue&type=template&id=35e545c8"
import script from "./grassRootsPartySchool.vue?vue&type=script&lang=js"
export * from "./grassRootsPartySchool.vue?vue&type=script&lang=js"
import style0 from "./grassRootsPartySchool.vue?vue&type=style&index=0&id=35e545c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports